'use client';

import { useCartInfoAtom } from '@/state';
import { useCallback, useRef } from 'react';
import { type SignInAndMergeArgs, signInAndMerge } from './signInAndMerge';

/**
 * `signInAndMerge` を React hook として使えるようにする薄いラッパ。
 * Jotai atom から最新のカート情報を取り出して `signInAndMerge` に渡す。
 *
 * 遷移は呼ばないので、成功時の `/cart` 誘導は戻り値の outcome を見て呼び出し側で行う。
 * ログイン後の Router Cache 無効化（router.refresh）は呼び出し側で `router.push` の直後に行う必要がある
 * （ここで refresh しても `/auth/signin` 画面の RSC を再フェッチするだけで push 先のキャッシュには効かないため）。
 */
export const useSignInWithCartMerge = () => {
  const [cartInfo, , clearCartInfo] = useCartInfoAtom();
  const cartInfoRef = useRef(cartInfo);
  cartInfoRef.current = cartInfo;

  const signInWithCartMerge = useCallback(
    (args: SignInAndMergeArgs) =>
      signInAndMerge(
        {
          getItems: () => cartInfoRef.current.items ?? [],
          clearCartInfo,
        },
        args,
      ),
    [clearCartInfo],
  );

  return { signInWithCartMerge };
};
